import { HariseninFooter } from "@components/harisenin"
import { Header } from "@components/header"
import Helmet from "@helpers/Helmet"
import { SchoolDetail } from "@interfaces/school"
// import { useAnalytics } from "@lib/context/analytics"
import { textShortener } from "@lib/functions"
import { useScreenSize } from "@lib/hooks/useScreenSize"
import { useUserData } from "@lib/hooks/useUserData"
import dynamic from "next/dynamic"
import { useRouter } from "next/router"
import { FC, useEffect, useState } from "react"
import {
  BootcampAlumnus,
  BootcampBanner,
  BootcampComparison,
  BootcampCurriculum,
  BootcampFaq,
  BootcampFee,
  BootcampLearnMethod,
  BootcampNavigator,
  BootcampOutcomes,
  BootcampOverview,
  BootcampPayments,
  BootcampPortfolio,
  BootcampRegistrations,
  BootcampSchedule,
  BootcampSpecialization,
  BootcampTestimonial,
  BootcampTutors,
  BootcampCommunity,
} from "./components/bootcamp"
import BootcampVideo from "./components/bootcamp/BootcampVideo"
import { ProgramCta } from "./components/general"
import TestimonialVideoRow from "./components/bootcamp/TestimonialVideoRow"
import InfiniteUserPopup from "@components/alert/InfiniteUserPopup"

const FloatingWhatsApp = dynamic(() => import("@harisenin/react-floating-whatsapp"), { ssr: false })

export interface ProgramLandingPageProps {
  schoolDetail?: SchoolDetail
  schema?: any
  videoSchemas?: any
  videoTestimonies?: any
}

const ProgramLandingPage: FC<ProgramLandingPageProps> = ({
  schoolDetail,
  schema,
  videoSchemas,
  videoTestimonies,
}) => {
  const [isTransparent, setIsTransparent] = useState(true)

  const { screenWidth } = useScreenSize()
  // const { analytics } = useAnalytics()
  const { tokenData, isLogin } = useUserData()

  const videoSchema = videoSchemas.map((sch) => {
    return {
      ...sch,
      uploadDate: new Date(sch.uploadDate).toUTCString(),
    }
  })
  // useEffect(() => {
  //   analytics.track("Product Viewed", {
  //     products: [
  //       {
  //         product_id: "",
  //         name: `${schoolDetail.product_name}`,
  //         affiliation: "PT. Karya Kaya Bahagia",
  //         coupon: "",
  //         discount: 0,
  //         currency: "IDR",
  //         brand: "HMS",
  //         category: "Bootcamp",
  //         variant: "",
  //         price: "",
  //         quantity: 1,
  //         position: 0,
  //         item_list_name: schoolDetail.product_name,
  //         item_list_id: schoolDetail.product_id,
  //       },
  //     ],
  //     currency: "IDR",
  //     value: 0,
  //   })
  // }, [])

  useEffect(() => {
    window.addEventListener("scroll", trackScrolling)

    return () => {
      window.removeEventListener("scroll", trackScrolling)
    }
  }, [])

  function isBottom(el: HTMLElement) {
    const cursorPos = document.documentElement.scrollTop

    return cursorPos + 60 >= el.offsetTop
  }

  const trackScrolling = () => {
    const wrappedElement = document.getElementById("header1")
    isBottom(wrappedElement)

    if (isBottom(wrappedElement)) {
      setIsTransparent(false)
    } else {
      setIsTransparent(true)
    }
  }

  const executeScroll = (id: string) => () => {
    const ele = document.getElementById(id)

    if (!ele) {
      return
    }

    ele.scrollIntoView({ behavior: "smooth" })
  }
  
  return (
    <>
      <FloatingWhatsApp
        phoneNumber="+6281312117711"
        accountName="Customer Services"
        allowClickAway
        notification
        notificationDelay={30000}
        styles={{
          ...(screenWidth < 576 && {
            bottom: "5rem",
            right: "1rem",
          }),
        }}
      />
      <InfiniteUserPopup />
      <Helmet
        isIndexed
        title={schoolDetail?.school_meta_title || `${schoolDetail?.product_name} - Harisenin.com`}
        description={
          schoolDetail?.school_meta_description ||
          textShortener(schoolDetail?.product_description, 280)
        }
        schemaMarkup={[schema, ...videoSchema]}
      />
      <div className="relative font-inter">
        <Header transparent={isTransparent} isNotSticky />
        <BootcampBanner schoolDetail={schoolDetail} scroll={executeScroll("fee")} />

        <div className="sm:pt-20 relative">
          <BootcampNavigator schoolDetail={schoolDetail} />
          <BootcampOverview schoolDetail={schoolDetail} />
          <BootcampOutcomes schoolDetail={schoolDetail} />
          <BootcampAlumnus schoolDetail={schoolDetail} />
          <BootcampVideo videos={schoolDetail.school_video_previews} screenWidth={screenWidth} />
          <BootcampSpecialization
            specialization={schoolDetail.school_specializations}
            screenWidth={screenWidth}
            info={schoolDetail.school_specialization_properties}
          />
          <BootcampCurriculum
            schoolDetail={schoolDetail}
            tokenData={tokenData}
            isLogin={isLogin}
            screenWidth={screenWidth}
          />
          <BootcampTutors tutors={schoolDetail.school_tutors} />
          <BootcampLearnMethod methods={schoolDetail.school_learning_experiences_images} />
          <TestimonialVideoRow
            testimonies={schoolDetail.school_testimony_videos}
            screenWidth={screenWidth}
          />
          <BootcampTestimonial
            testimonials={schoolDetail.school_testimonies}
            screenWidth={screenWidth}
          />
          <BootcampPortfolio portfolios={schoolDetail.school_portfolio} screenWidth={screenWidth} />
          <BootcampCommunity screenWidth={screenWidth} />
          <BootcampComparison />
          <BootcampSchedule batches={schoolDetail.school_batch} scroll={executeScroll} />
          <BootcampFee schoolDetail={schoolDetail} screenWidth={screenWidth} />
          <BootcampRegistrations />
          <BootcampPayments />
          <BootcampFaq faqs={schoolDetail.school_faqs} />
        </div>
        <ProgramCta isBootcamp />
      </div>
      <HariseninFooter />
    </>
  )
}

export default ProgramLandingPage
